import PropTypes from 'prop-types';
import { Box, Card } from '@qga/roo-ui/components';
import ContentHeading from 'components/Typography/ContentHeading';
import HorizontalRule from 'components/Layout/HorizontalRule';
import { FormattedCalendarDate } from 'components/Formatters';
import { ItemGroup, GroupHeading, GroupItems, Item } from 'components/ReviewCard';

const RequestDetails = ({ checkIn, checkOut, phoneNumber, email, ...rest }) => (
  <Box {...rest}>
    <ContentHeading data-testid="change-date-request-details-title" mb={4} fontSize={['xl', '2xl']}>
      Request details
    </ContentHeading>
    <Card p={0}>
      <ItemGroup data-testid="change-date-request-details-new-stay-dates">
        <GroupHeading>New stay dates</GroupHeading>
        <GroupItems>
          <Item data-testid="new-check-in-date" labelItem="Check-in" valueItem={<FormattedCalendarDate date={checkIn} />} boldValue />
          <Item data-testid="new-check-out-date" labelItem="Check-out" valueItem={<FormattedCalendarDate date={checkOut} />} boldValue />
        </GroupItems>
      </ItemGroup>
      <HorizontalRule mx={[0, 5]} my={0} />
      <ItemGroup data-testid="change-date-request-details-contact-details">
        <GroupHeading>Your contact details</GroupHeading>
        <GroupItems>
          <Item data-testid="phone-number" labelItem="Phone number" valueItem={phoneNumber} />
          <Item data-testid="email-address" labelItem="Email" valueItem={email} />
        </GroupItems>
      </ItemGroup>
    </Card>
  </Box>
);

RequestDetails.propTypes = {
  checkIn: PropTypes.string.isRequired,
  checkOut: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export default RequestDetails;
